(ns frontend.ui.component.lp-portal.modal.edit-modals.common
  (:require
   [common.localization :as loc]
   [frontend.ui.component.lp-portal.modal.edit-modals.events :as chart-editor-events]
   [frontend.ui.component.lp-portal.modal.style :as style]
   [herb.core :as h]
   [ui.components.button.view :as button]
   [ui.components.radix-ui.dropdown-menu.view :as dropdown-menu]
   [ui.editors.data-input :as data-input]
   [frontend.tenant-customizations :as tenant-customizations]))

(def multiplier-options
  (remove nil?
          [{:value 1
            :label (loc/tr :no-multiplier)}
           {:value 1000
            :label (loc/tr :thousand-multiplier)}
           {:value 1000000
            :label (loc/tr :million-multiplier)}
           {:value 1000000000
            :label (loc/tr :billion-multiplier)}
           (when (tenant-customizations/capman?)
             {:value "auto"
              :label (loc/tr :auto-multiplier)})]))

(def axis-side-options
  [{:value "right"
    :label "Right"}
   {:value "left"
    :label "Left"}])

(def graph-type-options
  [{:value "column"
    :label "Column"}
   {:value "line"
    :label "Line"}])

(defn row-dropdown
  [{:keys [state add-row-to-index-before! add-row-to-index-after! remove-row!
           insert-row-type-options]}]
  [dropdown-menu/view
   {:trigger-as-child
    [:div
     {:class (h/<class style/cell-dropdown-trigger)}
     [:span
      {:class (h/<class style/cell-dropdown-trigger-span)}
      [:i.fas.fa-ellipsis-v]]]
    :items (into []
                 (concat (when (fn? add-row-to-index-before!)
                           [(if (seq insert-row-type-options)
                              {:label        (loc/tr :insert-row-before)
                               :items        (into [{:section-label? true
                                                     :label (loc/tr :select-data-type)}]
                                                   (mapv (fn [{:keys [value label]}]
                                                           {:label    label
                                                            :on-click #(add-row-to-index-before! value)})
                                                         insert-row-type-options))
                               :custom-class (h/<class style/table-dropdown-item-no-icon false)}
                              {:label        (loc/tr :insert-row-before)
                               :on-click     (fn [_]
                                               (add-row-to-index-before!))
                               :custom-class (h/<class style/table-dropdown-item-no-icon false)})])
                         [(if (seq insert-row-type-options)
                            {:label        (loc/tr :insert-row-after)
                             :items        (into [{:section-label? true
                                                   :label (loc/tr :select-data-type)}]
                                                 (mapv (fn [{:keys [value label]}]
                                                         {:label    label
                                                          :on-click #(add-row-to-index-after! value)})
                                                       insert-row-type-options))
                             :custom-class (h/<class style/table-dropdown-item-no-icon false)}
                            {:label        (loc/tr :insert-row-after)
                             :on-click     (fn [_]
                                             (add-row-to-index-after!))
                             :custom-class (h/<class style/table-dropdown-item-no-icon false)})]
                         (when (fn? remove-row!)
                           [{:label        (loc/tr :delete-row)
                             :on-click     remove-row!
                             :custom-class (h/join (h/<class style/table-dropdown-item-no-icon (->> @state
                                                                                                   :data
                                                                                                   (count)
                                                                                                   (= 1)))
                                                   (h/<class style/remove-icon))}])))
    :props {:side  "bottom"
            :align "end"}}])

(defn header-dropdown
  [{:keys [state
           add-column-to-index-before!
           add-column-to-index-after!
           remove-column!
           extra-items
           insert-column-type-options]}]
  [dropdown-menu/view
   {:trigger-as-child
    [:button
     {:class (h/<class style/cell-dropdown-trigger)}
     [:span
      {:class (h/<class style/cell-dropdown-trigger-span)}
      [:i.fas.fa-ellipsis-v]]]
    :items (into []
                 (concat (when (fn? add-column-to-index-before!)
                           [(if (seq insert-column-type-options)
                              {:label        (loc/tr :insert-column-before)
                               :items        (into [{:section-label? true
                                                     :label (loc/tr :select-data-type)}]
                                                   (mapv (fn [{:keys [value label]}]
                                                           {:label    label
                                                            :on-click #(add-column-to-index-before! value)})
                                                         insert-column-type-options))
                               :custom-class (h/<class style/table-dropdown-item-no-icon false)}
                              {:label        (loc/tr :insert-column-before)
                               :on-click     (fn [_]
                                               (add-column-to-index-before!))
                               :custom-class (h/<class style/table-dropdown-item-no-icon false)})])
                         [(if (seq insert-column-type-options)
                            {:label        (loc/tr :insert-column-after)
                             :items        (into [{:section-label? true
                                                   :label (loc/tr :select-data-type)}]
                                                 (mapv (fn [{:keys [value label]}]
                                                         {:label    label
                                                          :on-click #(add-column-to-index-after! value)})
                                                       insert-column-type-options))
                             :custom-class (h/<class style/table-dropdown-item-no-icon false)}
                            {:label        (loc/tr :insert-column-after)
                             :on-click     (fn [_]
                                             (add-column-to-index-after!))
                             :custom-class (h/<class style/table-dropdown-item-no-icon false)})]
                         extra-items
                         (when (fn? remove-column!)
                           [{:label        (loc/tr :delete-column)
                             :on-click     remove-column!
                             :custom-class (h/join (h/<class style/table-dropdown-item-no-icon (->> @state
                                                                                                   :columns
                                                                                                   (count)
                                                                                                   (= 1)))
                                                   (h/<class style/remove-icon))}])))
    :props {:side  "bottom"
            :align "end"}}])

(defn table-header-row
  [state {:keys [no-columns? fixed-labels? fixed-columns? has-colors? add-column-to-index! remove-column!]}]
  (let [columns (:columns @state)
        highlight-figures? (:highlight-figures? @state)]
    [:thead
     (into
      [:tr]
      (concat (when-not (or highlight-figures? no-columns?)
                [[:th
                  {:class (h/<class style/th)}
                  (loc/tr :labels)]])
              [(when-not (->> @state
                              :columns
                              (seq))
                 [button/secondary-hollow
                  {:on-click #(chart-editor-events/add-column! state false)}
                  (loc/tr :no-chart-data-available)])]
              (->> columns
                   (map-indexed
                    (fn [idx col]
                      (let [value (str col)]
                        ^{:key (str idx "/" (count columns))}
                        [:th
                         {:class (h/<class style/table-header-cell-container)}
                         [:div
                          {:class (h/<class style/table-header-cell)
                           :id    "header-cell"}
                          [data-input/view
                           {:data-type :data.type/text-simple
                            :class     (h/<class style/table-header-input fixed-labels?)
                            :value     value
                            :on-change  #(chart-editor-events/update-heading! state idx %)
                            :disabled? fixed-labels?}]
                          (when-not fixed-columns?
                            [header-dropdown
                             {:state state
                              :add-column-to-index-before! #(add-column-to-index! state idx has-colors?)
                              :add-column-to-index-after! #(add-column-to-index! state (+ idx 1) has-colors?)
                              :remove-column! #(remove-column! state idx has-colors?)}])]]))))))]))

(defn numerical-cells-row
  [{:keys [state row-idx row-data update-value!]}]
  (let [columns (if (:columns @state) ;;TODO FIX
                  (:columns @state)
                  (:series-categories @state))
        column-count (count columns)
        name-not-editable? (not (some #{(:chart-key @state)} [:financials :net-debt
                                                              :valuation :distribution-yield]))]
    (->> (range 0 (inc column-count)) ;; label column is not in :columns
         (map
          (fn [col-idx]
            (let [col-value (when (> (count row-data) col-idx)
                              (nth row-data col-idx))]
              [:td
               {:class (h/<class style/table-cell false)}
               (cond
                 (and (= col-idx 0) name-not-editable?)
                 [:span
                  {:class (h/<class style/title)}
                  (str col-value)]
                 (= col-idx 0)
                 [data-input/view
                  {:data-type :data.type/text-simple
                   :class     (h/<class style/table-header-input false)
                   :value     (str col-value)
                   :on-change  #(update-value!
                                state
                                row-idx
                                col-idx
                                %)
                   :disabled? false}]
                 :else
                 ^{:key (str (nth columns (dec col-idx)) "-" row-idx)}
                 [data-input/view
                  {:data-type    :data.type/number
                   :min-decimals 2
                   :max-decimals 2
                   :class        (h/join (h/<class style/number-input)
                                         (h/<class style/full-width))
                   :value        col-value
                   :on-change     #(update-value!
                                   state
                                   row-idx
                                   col-idx
                                   %)}])]))))))
